export const catalogMat = Signalman.featureFlag('catalog_mat');
export const subcatRedesign = Signalman.featureFlag('subcat_redesign_v5');
// prettier-ignore
export const newPricingDetails = Signalman.featureFlag('plp_pricing_details_v0');
export const previewUpload = Signalman.featureFlag('preview_upload_v9');
export const elevateSuperRush = Signalman.featureFlag('elevate_super_rush_v3');
